/**
 * ONE SUBMIT
 * @author frédéric Pineau
 * par artwaï pour artwaï
 *
 * ajoute une class submited sur les boutons submit après le click
 */
(function () {

	var forms = document.querySelectorAll('form');

	forms.forEach(function (form) {
		form.addEventListener('submit', function (e) {
			form.classList.add('submited')
		});
	});

}());